import React, { useEffect, useRef } from "react";

const ClickOutside = ({ 
  children,
  onClickOutside = () => {}, ...props }) => {
  const ref = useRef();

  useEffect(() => {
    document.addEventListener("click", handle, true);
    document.addEventListener("mousedown", handleMouseDown, true);

    return () => {
      document.removeEventListener("click", handle, true);
      document.removeEventListener("mousedown", handleMouseDown, true);
    };
  }, []);

  function handle(e) {
    const el = ref.current;
    if (el && !el.contains(e.target)) {
      // console.log('good');
      onClickOutside(e);
    }
  }

  function handleMouseDown(e) {
    const { onRightClick } = props;
    if (!onRightClick || e.button !== 2) return;
    // const el = container;
    // if (el && !el.contains(e.target)) onClickOutside(e);
    onRightClick(e);
  }

  return (
    <div {...props} ref={ref}>
      {children}
    </div>
  );
};

export default ClickOutside;
